// const locales = [
//     {
//         Name: 'Türkçe',
//         Value: 'tr-',
//     },
//     {
//         Name: 'English',
//         Value: 'en',
//     },
// ];

const dictionary = {
    "tr-TR": {
        Name: 'İsim',
        Surname: 'Soyisim',
        
    },
    "en-EN": {
        Name: 'Name',
        Surname: 'Surname'
    },
  };
  

export default {    

    getDictionary() {
      return dictionary;
    },
  };